export default menuBookingResort => {

    const btnBooking = menuBookingResort.querySelector('.cta-btn.booking');
    

    if(btnBooking){
      btnBooking.addEventListener('click', () => {
          menuBookingResort.classList.toggle('expanded')
      });
    }

    document.addEventListener('click', function(event) {
        var isClickInside = menuBookingResort.contains(event.target);

        if (!isClickInside) {
            menuBookingResort.classList.remove('expanded');
        }
    });



}
